// eslint-disable-next-line max-classes-per-file
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { TaggableNamed } from '../base/taggable-named';

@Metamodel.model({
    name: 'SqlSku'
})
export class SqlSku {
    @Metamodel.attribute({
    })
    public name?: string;

    @Metamodel.attribute({
    })
    public tier?: string;
    @Metamodel.attribute({
    })
    public capacity?: number;
}

@Metamodel.model({
    name: ModelConstants.sqlPool,
    display: [shellStringResources.SynapseSqlPools],
    reusable: true,
    referable: true,
    transient: true // Make it transient as we don't need it persist via Shell for now
})
export class SqlPool extends TaggableNamed {
    @Metamodel.attribute({
    })
    public rawTags: { [key: string]: string };

    @Metamodel.attribute({
    })
    public location: string;

    @Metamodel.attribute({
    })
    public kind: string;

    @Metamodel.attribute({
    })
    public sku?: SqlSku;

    @Metamodel.attribute({
    })
    public collation?: string;

    @Metamodel.attribute({
    })
    public creationDate?: string;

    @Metamodel.attribute({
    })
    public maxSizeBytes?: number;

    @Metamodel.attribute({
    })
    public provisioningState?: string;

    @Metamodel.attribute({
    })
    public restorePointInTime?: string;

    @Metamodel.attribute({
    })
    public sourceDatabaseId?: string;

    // represent status property of SDK model
    // but status is already part of Named
    // so sqlPoolStatus
    @Metamodel.attribute({
    })
    public sqlPoolStatus?: string;

    public currentServiceObjectiveName?: string;

    @Metamodel.attribute({
    })
    public recoverableDatabaseId?: string;

    @Metamodel.attribute({
    })
    public createMode?: string;
}
